import React from 'react';

import i18n from 'i18next';

import getAgendaItemModelDefaults from './getAgendaItemModelDefaults';

import getNewLiveVideoSchema from '../schemas/getNewLiveVideoSchema';

import NewLiveVideoForm from '../components/newLiveVideoForm';

export default (model, { adminSettings, currentUser }) => {
  const id = 'new-live-video';

  return {
    component: <NewLiveVideoForm id={id} schema={getNewLiveVideoSchema({ adminSettings })} />,
    hasCloseButton: true,
    id,
    isFullScreen: true,
    model: { ...model, agenda_item: getAgendaItemModelDefaults({ currentUser }) },
    title: i18n.t('create-new-live-video'),
  };
};
